import Node from '../ui/Node';
import Element from '../ui/Element';
import * as members from '../privates/privateMembers';
import reporter from '../privates/reporter';
import {generateError} from '../privates/validations/errors';
import {setStageUnfriendlyFunctions} from '../privates/utils/livePreview';

const validateRelatedTo = (reject, relatedTo) => {
    if (relatedTo instanceof Element) {
        return true;
    }

    const errorMessage = generateError.error_type({
        propertyName: 'relatedTo',
        functionName: 'showPopover',
        wrongValue: relatedTo,
        expectedType: 'Element'
    });
    reporter.reportSdkError(errorMessage);
    reject(new Error(errorMessage));
    return false;
};

class Popover extends Node {

    showPopover(relatedTo) {
        return new Promise((resolve, reject) => {
            const RMI = members._RMI.get(this);

            if (!validateRelatedTo(reject, relatedTo)) {
                return;
            }

            const popoverId = members._compId.get(this);
            const targetId = members._compId.get(relatedTo);

            RMI.executeCompBehavior(popoverId, 'showPopover', {targetId}, resolve);
        });
    }
    
    hidePopover() {
        return new Promise((resolve) => {
            const RMI = members._RMI.get(this);
            const popoverId = members._compId.get(this);
            RMI.executeCompBehavior(popoverId, 'hidePopover', {}, resolve);
        });
    }
}
setStageUnfriendlyFunctions(Popover, 'showPopover');

export default Popover;
